import { render, staticRenderFns } from "./OrdersScheduleLaundryDelivery.vue?vue&type=template&id=45e87b1e&scoped=true"
import script from "./OrdersScheduleLaundryDelivery.vue?vue&type=script&lang=js"
export * from "./OrdersScheduleLaundryDelivery.vue?vue&type=script&lang=js"
import style0 from "./OrdersScheduleLaundryDelivery.vue?vue&type=style&index=0&id=45e87b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e87b1e",
  null
  
)

export default component.exports